import { axiosAPIInstance as axios, DashboardURL } from '../../axios-config';

const state = {
};

const getters = {
  dashboardsEnabled() {
    return !!DashboardURL;
  },
  dashboardInstanceBaseURL() {
    return DashboardURL;
  },
  activeDashboardLink(
    state,
    { dashboardsEnabled, dashboardInstanceBaseURL },
    rootState,
    { activeClass, authToken }
  ) {
    console.log({ dashboardsEnabled, activeClass, authToken });
    if (dashboardsEnabled && activeClass && activeClass.defaultDashboardId) {
      const query = `?token=${encodeURIComponent(authToken)}`;
      // return `${dashboardInstanceBaseURL}/${query}#/dashboard/${activeClass.defaultDashboardId}/`;
      return `${dashboardInstanceBaseURL}/${query}#/dashboard/${activeClass.defaultDashboardId}/`;
    }
    return null;
  }
};

const mutations = {
};

const actions = {
  async getDashboards() {
    const response = await axios.get('/dashboards/');
    return response.data.dashboards;
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/dashboards/dashboards.js